module.exports = __webpack_public_path__ + "img/agregar-tarjeta.0656611c.png";